import { computed, makeObservable, observable, runInAction } from 'mobx';
import { AddOn, AddOnType } from '@monorepo/types';
import { getEnv } from '@hub/helpers/getters.store';

export class AddOnStore {
  @observable
  _items: Map<string, AddOn> = new Map();

  constructor() {
    makeObservable(this);
  }

  async getAddOnsForAccount(accountId: string) {
    const {
      apiFactory: { addOnService },
    } = getEnv();

    this._items.clear();
    const items = await addOnService.getAddOnsForAccount(accountId);
    runInAction(() => {
      items.forEach((item) => {
        this._items.set(item._id, item);
      });
    });
  }

  getAddOns(type?: AddOnType) {
    const items = Array.from(this._items.values());

    if (!type) {
      return items;
    }
    return items.filter((item) => item.type === type);
  }

  get(id: string) {
    return this._items.get(id);
  }

  @computed
  get items() {
    return Array.from(this._items.values());
  }
}
